import { useLinked, Linked } from "@type-r/react";
import * as React from "react";
import { PopupIODialog, CompactTextArea, SelectFile } from "lqx-react";
import { OrderModel } from "api";
import { ShowOrdersDiff } from "./supplier";
import { Alert, AlertTitle } from "@material-ui/lab";

export const HoldPODialog = ({
  $isOpen,
  order
}: {
  $isOpen: Linked<boolean>;
  order: OrderModel;
}) =>
  order.isDistributorHold ? (
    <ReleasePODialog $isOpen={$isOpen} order={order} />
  ) : (
    <PopupIODialog
      $isOpen={$isOpen}
      title="Hold Purchase Order"
      actionLabel="Hold"
      success="Purchase order placed on hold"
      doIO={() => order.doHold(true)}
    >
      Are you sure to hold this purchase order?
    </PopupIODialog>
  );

export const ReleasePODialog = ({
  $isOpen,
  order
}: {
  $isOpen: Linked<boolean>;
  order: OrderModel;
}) => (
  <PopupIODialog
    $isOpen={$isOpen}
    title="Release Purchase Order"
    actionLabel="Release"
    success="Purchase order released"
    doIO={() => order.doHold(false)}
  >
    Are you sure to release this purchase order?
  </PopupIODialog>
);

export const CancelPODialog = ({ $isOpen, order }) => (
  <PopupIODialog
    $isOpen={$isOpen}
    title="Cancel Purchase Order"
    actionLabel="Cancel PO"
    success="Purchase order cancelled"
    doIO={async () => {
      await order.doCancel();
      await order.fetch();
    }}
  >
    Are you sure to cancel this purchase order?
  </PopupIODialog>
);

export const SubmitPODialog = ({
  $isOpen,
  order,
  fetchedOrder
}: {
  $isOpen: Linked<boolean>;
  order: OrderModel;
  fetchedOrder: OrderModel;
}) => {
  const $comment = useLinked(""),
    $file = useLinked(null),
    file = $file.value;

  return (
    <PopupIODialog
      title="Submit PO"
      actionLabel="Submit"
      success="Purchase order was submitted"
      $isOpen={$isOpen}
      disabled={!order.hasPdfUploads && !file}
      doIO={async () => {
        file && (await order.doUpload(file, $comment.value, null, null));
        const isValidation = order.status === "PO Complete" ? false : true;
        await order.doSubmitPO({ commentOnSave: $comment.value, isValidation });
        await order.fetch();
      }}
    >
      <CompactTextArea autoFocus label="Comment" rows={10} $value={$comment} />

      {!order.hasPdfUploads ? (
        <>
          <Alert severity={file ? "success" : "warning"}>
            <AlertTitle>Purchase Order Attachment is Required</AlertTitle>
            Please, upload the purchase order in the PDF format.
          </Alert>
          <SelectFile accept=".pdf" label="Attachment" $value={$file} />
        </>
      ) : null}

      <ShowOrdersDiff order={order} fetchedOrder={fetchedOrder} />
    </PopupIODialog>
  );
};
